import React, { useState } from "react";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import { RatingComponent } from "../components/Rating";
import { FormWrapper } from "../components/Wrapper";
import { InputFail } from "../../../../Components/Form";
import InputSearchProps from "../../VedCourse/components/inputProps";

import Dots from "../../../../Components/Loader/Dots";

const AddRatingModule = ({
  sessionId,
  addRate,
  isLoading,
  isSuccess,
  placeholder,
  type,
}) => {
  const [ratingStarValue, setRatingStarValue] = useState(0);

  const validationSchema = Yup.object({
    comment: Yup.string().required("هذا الحقل مطلوب"),
  });

  const initialValues = {
    comment: "",
  };

  const onSubmit = ({ comment }, { resetForm }) => {
    addRate(
      type === "course"
        ? {
            course_id: sessionId,
            rating: ratingStarValue,
            comment: comment,
          }
        : {
            comment: comment,
            session_id: sessionId,
            rating: ratingStarValue,
          }
    );

    isSuccess && resetForm();
  };

  return (
    <>
      {isLoading ? (
        <Dots style={{ width: "100px", height: "100px" }} />
      ) : (
        <FormWrapper>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={onSubmit}
            style={{ width: "100%" }}
          >
            {({ errors }) => (
              <Form style={{ width: "100%" }} autoComplete="off">
                <Field
                  as={InputFail}
                  width="100%"
                  error={errors.comment}
                  errorText={errors.comment}
                  name="comment"
                  placeholder={placeholder}
                  inputProps={InputSearchProps}
                  borderradius="24px"
                  border="1px solid #00000029"
                  autoComplete="off"
                />
              </Form>
            )}
          </Formik>
          <RatingComponent
            readOnly={false}
            setRatingStarValue={setRatingStarValue}
            ratingValue={ratingStarValue}
          />
        </FormWrapper>
      )}
    </>
  );
};

export default AddRatingModule;
